import Button from "@mui/material/Button";
import { useTheme } from "@mui/material/styles";
import { useNavigate } from "react-router-dom";

interface Props {
  navigationLink: string;
  text: string;
  onClose?: () => void;
}

const CustomHeaderButton = ({
  navigationLink,
  text,
  onClose,
}: Props): JSX.Element => {
  const theme = useTheme();
  const navigate = useNavigate();
  const handleClick = () => {
    navigate(navigationLink);
    if (onClose) onClose();
  };
  return (
    <Button
      component="a"
      color="primary"
      onClick={handleClick}
      variant="text"
      sx={{
        color: theme.palette.text.primary,
        mx: 1.5,
        marginLeft: "15px",
        "&:active": {
          color:
            theme.palette.mode === "dark"
              ? theme.palette.primary.main
              : theme.palette.success.dark,
        },
        "&:hover": {
          color:
            theme.palette.mode === "dark"
              ? theme.palette.primary.main
              : theme.palette.success.dark,
        },
      }}
    >
      {text}
    </Button>
  );
};

export default CustomHeaderButton;
